<template>
  <picture >
    <source  type="image/webp" :srcset="getWebp(src)">
    <source  type="image/jpeg" :srcset="getImgUrl(src)">
    <img :class="imgClass"
      :src="getImgUrl(src)"
      :alt="alt"
    />
  </picture>
</template>

<script>
export default {
  name: "Picture",
  props: {
    src: String,
    alt: String,
    imgClass: String,
  },
  data(){
    return {};
  },
  methods: {
    getWebp(src){
      var pos = src.lastIndexOf(".");
      return this.getImgUrl(src.substr(0, pos < 0 ? src.length : pos) + ".webp");
    },
    getImgUrl(pic) {
      return require("../assets/" + pic);
    }
  }
};
</script>